import { css } from 'styled-components';

const CUSTOM_CSS = css`
  * {
    box-sizing: border-box;
    font-family: var(--fonts-body) !important;
  }

  html,
  body {
    padding: 0;
    margin: 0;
    font-family: var(--fonts-body) !important;
    color: var(--colors-black-light);
    touch-action: manipulation;
    -webkit-text-size-adjust: none;
  }

  html {
    line-height: 1.15;
  }

  body {
    line-height: 1.5715;
    font-variant: tabular-nums;
    font-feature-settings: 'tnum', 'tnum';
    font-size: 14px;
  }

  html,
  button,
  input,
  select,
  textarea {
    color: #222;
  }

  a {
    color: var(--colors-brand);
    text-decoration: none;

    &:hover {
      color: var(--colors-brand-dark);
    }
  }

  .chromeframe {
    margin: 0.2em 0;
    background: #ccc;
    color: #000;
    padding: 0.2em 0;
  }

  #nprogress {
    position: absolute;
    z-index: 9999999;
  }

  #botgate-iframe,
  #botgate-widget {
    z-index: 900 !important;
  }

  ::-webkit-scrollbar {
    width: 12px;
    height: 4px;
  }

  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 6px;
    border-radius: 6px;
    background-color: #cfd4de;
  }

  ::-webkit-scrollbar-track {
    background: white;
    -webkit-border-radius: 3px;
    border-radius: 3px;
  }

  .setur-select-selector .setur-select-selection-placeholder {
    color: var(--colors-input-placeholder-color);
    font-size: 16px;
  }
`;

export default CUSTOM_CSS;
